import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-446d3988"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 13,
  class: "w-full inline-flex my-2"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex w-full justify-end mt-2 px-3" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition duration-500 ease-in-out"
  }, "Salvesta")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CabinetsDropdown = _resolveComponent("CabinetsDropdown")!
  const _component_EquipmentsDropdown = _resolveComponent("EquipmentsDropdown")!
  const _component_XRayImagesAdd = _resolveComponent("XRayImagesAdd")!
  const _component_XRayUsageDropdown = _resolveComponent("XRayUsageDropdown")!
  const _component_XrayRadiationStatusDropdown = _resolveComponent("XrayRadiationStatusDropdown")!
  const _component_XRayMaintenanceIntervalDropdown = _resolveComponent("XRayMaintenanceIntervalDropdown")!
  const _component_MDatePicker = _resolveComponent("MDatePicker")!
  const _component_XRayYearSelectDropdown = _resolveComponent("XRayYearSelectDropdown")!
  const _component_InputField = _resolveComponent("InputField")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onEquipmentAdd && _ctx.onEquipmentAdd(...args)), ["prevent"])),
    class: "w-full flex flex-wrap"
  }, [
    (!_ctx.xRayEquipment && _ctx.isAdmin)
      ? (_openBlock(), _createBlock(_component_CabinetsDropdown, {
          key: 0,
          class: "w-full my-2 px-3",
          onOnCabinet: _cache[0] || (_cache[0] = (e) => (_ctx.cabinetUID = e)),
          "clinic-u-i-d": _ctx.clinicUID
        }, null, 8, ["clinic-u-i-d"]))
      : _createCommentVNode("", true),
    (!_ctx.xRayEquipment && _ctx.isAdmin)
      ? (_openBlock(), _createBlock(_component_EquipmentsDropdown, {
          key: 1,
          class: "w-full my-2 px-3",
          onOnEquipment: _ctx.onEquipment
        }, null, 8, ["onOnEquipment"]))
      : _createCommentVNode("", true),
    (!_ctx.xRayEquipment && _ctx.isAdmin)
      ? (_openBlock(), _createBlock(_component_XRayImagesAdd, {
          key: 2,
          class: "w-full px-3",
          onOnImages: _ctx.onImages
        }, null, 8, ["onOnImages"]))
      : _createCommentVNode("", true),
    (_ctx.isAdmin)
      ? (_openBlock(), _createBlock(_component_XRayUsageDropdown, {
          key: 3,
          class: "w-full sm:w-1/2 px-3 my-2",
          onOnUsage: _cache[1] || (_cache[1] = (e) => (_ctx.usageType = e)),
          "initial-usage": _ctx.xRayEquipment?.usageType
        }, null, 8, ["initial-usage"]))
      : _createCommentVNode("", true),
    (_ctx.isAdmin)
      ? (_openBlock(), _createBlock(_component_XrayRadiationStatusDropdown, {
          key: 4,
          class: "w-full sm:w-1/2 px-3 my-2",
          onOnStatus: _cache[2] || (_cache[2] = (e) => (_ctx.radiationStatusType = e)),
          "initial-radiation-status": _ctx.xRayEquipment?.radiationStatusType
        }, null, 8, ["initial-radiation-status"]))
      : _createCommentVNode("", true),
    (_ctx.isAdmin)
      ? (_openBlock(), _createBlock(_component_XRayMaintenanceIntervalDropdown, {
          key: 5,
          class: "w-full sm:w-1/2 px-3 my-2",
          onOnInterval: _cache[3] || (_cache[3] = e => _ctx.maintenanceIntervalsMonths = e),
          initial: _ctx.xRayEquipment?.maintenanceIntervalsMonths
        }, null, 8, ["initial"]))
      : _createCommentVNode("", true),
    _createVNode(_component_MDatePicker, {
      class: _normalizeClass(["w-full px-3 my-2", _ctx.isAdmin ? 'sm:w-1/2' : '']),
      onOnDate: _ctx.onLastMaintenanceDate,
      "initial-date": _ctx.lastMaintenanceDate ? new Date(_ctx.lastMaintenanceDate) : undefined,
      placeholder: "Viimase hoolduse kuupäev",
      label: ""
    }, null, 8, ["class", "onOnDate", "initial-date"]),
    (_ctx.isAdmin)
      ? (_openBlock(), _createBlock(_component_XRayYearSelectDropdown, {
          key: 6,
          class: "w-full sm:w-1/2 px-3 my-2",
          onOnYear: _cache[4] || (_cache[4] = (e) => (_ctx.manufactureYear = e)),
          "initial-year": _ctx.xRayEquipment?.manufactureYear
        }, null, 8, ["initial-year"]))
      : _createCommentVNode("", true),
    _createVNode(_component_MDatePicker, {
      class: _normalizeClass(["w-full px-3 my-2", _ctx.isAdmin ? 'sm:w-1/2' : '']),
      onOnDate: _ctx.onLastMeasurementDate,
      "initial-date": _ctx.lastMeasurementDate ? new Date(_ctx.lastMeasurementDate) : undefined,
      placeholder: "Viimase mõõdistuse kuupäev",
      label: ""
    }, null, 8, ["class", "onOnDate", "initial-date"]),
    (_ctx.isAdmin)
      ? (_openBlock(), _createBlock(_component_InputField, {
          key: 7,
          class: "w-full sm:w-1/2 px-3 my-2",
          label: "Seadme mudel",
          fieldId: "equipmentModel",
          isAutocomplete: false,
          required: "",
          value: _ctx.model,
          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model) = $event))
        }, null, 8, ["value"]))
      : _createCommentVNode("", true),
    (_ctx.isAdmin)
      ? (_openBlock(), _createBlock(_component_InputField, {
          key: 8,
          class: "w-full sm:w-1/2 px-3 my-2",
          label: "Seadme seerianumber",
          isAutocomplete: false,
          fieldId: "equipmentSerialNo",
          required: "",
          value: _ctx.serialNo,
          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.serialNo) = $event))
        }, null, 8, ["value"]))
      : _createCommentVNode("", true),
    (_ctx.isAdmin)
      ? (_openBlock(), _createBlock(_component_InputField, {
          key: 9,
          class: "w-full sm:w-1/2 px-3 my-2",
          label: "Maksimum torupinge (kV)",
          isAutocomplete: false,
          fieldId: "equipmentSerialNo",
          required: "",
          value: _ctx.maximumPipeVoltage,
          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.maximumPipeVoltage) = $event)),
          "input-type": _ctx.InputFieldType.NUMBER
        }, null, 8, ["value", "input-type"]))
      : _createCommentVNode("", true),
    (_ctx.isAdmin)
      ? (_openBlock(), _createBlock(_component_InputField, {
          key: 10,
          class: "w-full sm:w-1/2 px-3 my-2",
          label: "Maksimum voolutugevus (mA)",
          isAutocomplete: false,
          fieldId: "equipmentModel",
          required: "",
          value: _ctx.maximumCurrent,
          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.maximumCurrent) = $event)),
          "input-type": _ctx.InputFieldType.NUMBER
        }, null, 8, ["value", "input-type"]))
      : _createCommentVNode("", true),
    (_ctx.isAdmin)
      ? (_openBlock(), _createBlock(_component_InputField, {
          key: 11,
          class: "w-full sm:w-1/2 px-3 my-2",
          label: "Tootja",
          fieldId: "equipmentModel",
          isAutocomplete: false,
          required: "",
          value: _ctx.manufacturer,
          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.manufacturer) = $event))
        }, null, 8, ["value"]))
      : _createCommentVNode("", true),
    (_ctx.isAdmin)
      ? (_openBlock(), _createBlock(_component_InputField, {
          key: 12,
          class: "w-full sm:w-1/2 px-3 my-2",
          label: "Tootjariik",
          fieldId: "equipmentModel",
          isAutocomplete: false,
          required: "",
          value: _ctx.manufacturerCountry,
          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.manufacturerCountry) = $event))
        }, null, 8, ["value"]))
      : _createCommentVNode("", true),
    (_ctx.isAdmin)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_InputField, {
            class: "w-full sm:w-1/2 px-3",
            label: "Röntgentoru mudel",
            isAutocomplete: false,
            fieldId: "equipmentModel",
            required: "",
            value: _ctx.xRayTubeModel,
            "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.xRayTubeModel) = $event))
          }, null, 8, ["value"]),
          _createVNode(_component_InputField, {
            class: "w-full sm:w-1/2 px-3",
            label: "Röntgentoru seerianumber",
            isAutocomplete: false,
            fieldId: "equipmentModel",
            required: "",
            value: _ctx.xRayTubeSerialNo,
            "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.xRayTubeSerialNo) = $event))
          }, null, 8, ["value"])
        ]))
      : _createCommentVNode("", true),
    _hoisted_2
  ], 32))
}